import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";


declare var ko: any;

export class networkGroupEdit_template extends vnTemplate {
    
    protected getTemplateHtml(): string {

        return `
                   
            <div class="form-header" data-bind="with: networkGroup">
                <input type="hidden">
                
                <!-- ko ifnot: $parent.idNetworkGroup() -->
                <h3 class="form-title icon i-group">Add Network Group</h3>
                <!-- /ko -->
                
                <!-- ko if: $parent.idNetworkGroup() -->
                <h3 class="form-title icon i-role" data-bind="text: name"></h3>
                <!-- /ko -->

                <button data-bind="event: { click: $parent.onClickCancel }" class="close-button icon i-close" type="button"></button>
            </div>
            
            <div id="view-results">
    
                <div data-bind="with: networkGroup">
                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group">
                                <label class="form-label">Id</label>
                                <div class="w-input">
                                    <input type="text" name="id" id="id" disabled class="input-text is-disable" data-bind="value: id">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Name</label>
                                <div class="w-input">
                                    <input type="text" name="name" id="name" class="input-text" data-bind="value: name">
                                </div>
                            </div>
                        </div> 
                        <div class="form-body">
                            <div class="form-group">
                                <legend class="form-legend">Network Categories</legend>
                                <div data-bind="foreach: $parent.networks">
                                    <div class="form-check-inline">
                                        <input type="checkbox" data-bind="attr: {id: 'network_' + id}, value: id, checked: selected">
                                        <label class="form-label icon i-check"  data-bind="text: name, attr: {for: 'network_' + id}"></label>
                                    </div> 
                                </div>
                            </div>           
                        </div>   
                    </div>  
                   
                <div class="form-footer">
                    <button class="btn" type="button" data-bind="click: $parent.onClickCancel">Cancel</button>
                    <button class="btn highlight" type="button" data-bind="click: $parent.onClickSave">Save</button>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string {
        return "usersEdit-form-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large", "margin-top", "roles-view"];
    }

    protected buildViewModel(): any {

        let myself = this;
        return {
            idNetworkGroup: ko.observable(""),
            networkGroup: ko.observable(),
            networks: ko.observableArray([]),
            onClickSave: function (data, event) {
                myself.onClickSave();
            },
            onClickCancel: function (data, event) {
                myself.onClickCancel();
            }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        let networkGroup = this.getTemplateViewModel().networkGroup();
        delete networkGroup["networks"];
        return {
            networkGroup : networkGroup,
            networks: this.getSelectedNetworks()
        }
    }

    //
    // click on save button
    protected onClickSave(): void {
        this.caller.saveEditNetworkGroup();
    }

    //
    // click on cancel button
    protected onClickCancel(): void {
        this.caller.cancelEditNetworkGroup();
    }


    private getSelectedNetworks(): Array<number> {

        let selectedNetworks = [];
        this.getTemplateViewModel().networks().forEach((network) => {

            if (network.selected == true) {

                selectedNetworks.push(network.id);
            }
        });

        return selectedNetworks;
    }

    public setNetworkGroup(networkGroup: {id: number, name: string, description: string, networks: Array<{id: number, idGroup: number,idNetworkCategory: number, dateCreated: string }>}): void {

        this.getTemplateViewModel().networkGroup(networkGroup);
    }

    /**
     *
     * @param networks
     */
    public setNetworks(networks: Array<{ id: number, name: string, description: string}>): void {


        let selectedNetwork = [];
        selectedNetwork = this.getTemplateViewModel().networkGroup().networks;

        networks.forEach((network) => {
            let isSelected = false;
            selectedNetwork.forEach((sn) => {
                if (network.id == sn.idNetworkCategory) {
                    isSelected = true;
                }
            });
            network['selected'] = isSelected;
        });
        this.getTemplateViewModel().networks(networks);
    }

    //
    // error
    protected onUpdateError(status, data): void {
        console.log('onUpdateError' + status);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/networkGroupEdit_template.ts